import ScrollReveal from "@/components/ScrollReveal";

const divisions = [
  {
    name: "DrkLynX",
    nameStyle: "font-sans font-black tracking-[0.25em] uppercase text-slate-400 text-xl md:text-2xl",
    role: "Threat Intelligence & Counterparty Risk",
    description: "Real-time adversarial intelligence, dark web monitoring, and counterparty risk profiling for institutional clients.",
    established: "2024",
  },
  {
    name: "NoirLynX Intelligence",
    nameStyle: "font-serif font-light tracking-[0.18em] uppercase text-slate-300 text-xl md:text-2xl",
    role: "On-Chain Forensics & Compliance",
    description: "Blockchain forensics, transaction tracing, and AML/KYC compliance tooling for regulated financial institutions.",
    established: "2024",
  },
  {
    name: "JetHostHub",
    nameStyle: "font-sans font-bold tracking-tight text-slate-200 text-xl md:text-2xl",
    role: "Sovereign Infrastructure Services",
    description: "Bare-metal hosting, sovereign cloud provisioning, and managed infrastructure with guaranteed data residency.",
    established: "2025",
  },
];

export default function DivisionLogos() {
  return (
    <section
      id="divisions"
      data-testid="division-logos"
      className="py-28 md:py-36 lg:py-44 px-6 md:px-12"
    >
      <div className="max-w-7xl mx-auto">
        <ScrollReveal>
          <div className="text-center mb-20">
            <p className="text-xs tracking-[0.2em] uppercase text-slate-500 font-sans mb-4">
              The JCAM Family
            </p>
            <h2
              data-testid="divisions-heading"
              className="font-serif text-3xl md:text-4xl font-bold text-white tracking-tight"
            >
              Operating Companies
            </h2>
          </div>
        </ScrollReveal>

        <div className="space-y-0">
          {divisions.map((div, i) => (
            <ScrollReveal key={div.name} delay={i * 0.1}>
              <div
                data-testid={`division-${i}`}
                className="border-t border-slate-800 py-10 md:py-14 group hover:bg-[#0A1325]/30 transition-colors duration-500 -mx-6 md:-mx-12 px-6 md:px-12"
              >
                <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 items-center">
                  {/* Index + Name */}
                  <div className="md:col-span-5 flex items-center gap-6">
                    <span className="text-xs text-slate-700 font-sans tabular-nums w-6 text-right">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <div>
                      <span className={`${div.nameStyle} block`}>{div.name}</span>
                    </div>
                  </div>

                  {/* Role */}
                  <div className="md:col-span-3">
                    <span className="text-xs tracking-[0.12em] uppercase text-[#D4AF37]/60">
                      {div.role}
                    </span>
                  </div>

                  {/* Description */}
                  <div className="md:col-span-3">
                    <p className="text-xs text-slate-500 leading-relaxed">
                      {div.description}
                    </p>
                  </div>

                  {/* Year */}
                  <div className="md:col-span-1 text-right">
                    <span className="text-xs text-slate-700 font-sans">{div.established}</span>
                  </div>
                </div>
              </div>
            </ScrollReveal>
          ))}
          {/* Bottom border */}
          <div className="border-t border-slate-800" />
        </div>
      </div>
    </section>
  );
}
